import { createColumnHelper } from '@tanstack/react-table';

import { ApplicationRowData } from './types';

export const helper = createColumnHelper<ApplicationRowData>();
